import React from 'react'
import { Link } from 'react-router-dom'
import Style from '../updates.module.css'
import { useGetMarketplaceEndpointsQuery } from '../../../../features/marketplace/marketplaceApi'
import { useConnectionCreateAccess } from '../../../../features/clientUsers/useClientAccess'
import { PATH, paths } from '../../../../app/routes'

const POPULAR_LIMIT = 8
const EMPTY = []

const TYPE_LABEL = { Erp: 'ERP', Ecommerce: 'eCommerce' }

const initials = (name) => (name || '?').replace(/[^A-Za-z0-9 ]/g, '').split(/\s+/).map((part) => part[0]).join('').slice(0, 2).toUpperCase()

const SystemCard = ({ endpoint, canConnect }) => (
    <article className={Style.system}>
        <span className={Style.systemLogo}>
            {endpoint.image ? <img src={endpoint.image} alt="" /> : <span aria-hidden="true">{initials(endpoint.shortName)}</span>}
        </span>
        <span className={Style.systemName} title={endpoint.fullName || endpoint.shortName}>{endpoint.shortName}</span>
        {TYPE_LABEL[endpoint.type] ? <span className={Style.systemType}>{TYPE_LABEL[endpoint.type]}</span> : null}
        {canConnect ? (
            <Link
                to={paths.newConnector({ system: endpoint.id })}
                className={Style.connectButton}
                aria-label={`Connect ${endpoint.shortName}`}
            >
                Connect
            </Link>
        ) : null}
    </article>
)

const PopularSystems = () => {
    const { data: endpoints = EMPTY, isLoading, isError, refetch } = useGetMarketplaceEndpointsQuery()
    const { canCreate } = useConnectionCreateAccess()

    const renderBody = () => {
        if (isLoading) {
            return (
                <div className={Style.systems} aria-busy="true">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <span key={index} className={Style.skeleton} style={{ height: 176 }} />
                    ))}
                </div>
            )
        }
        if (isError) {
            return (
                <div className={Style.stateMessage} role="alert">
                    The systems could not be loaded.
                    <button type="button" className={Style.retryButton} onClick={refetch}>Try again</button>
                </div>
            )
        }
        if (endpoints.length === 0) {
            return <div className={Style.stateMessage}>No systems are available yet.</div>
        }
        return (
            <div className={Style.systems}>
                {endpoints.slice(0, POPULAR_LIMIT).map((endpoint) => (
                    <SystemCard key={endpoint.id} endpoint={endpoint} canConnect={canCreate} />
                ))}
            </div>
        )
    }

    return (
        <section className={Style.section} aria-labelledby="systems-title">
            <div className={Style.sectionHeader}>
                <div>
                    <h2 id="systems-title" className={Style.sectionTitle}>Popular systems</h2>
                    <p className={Style.sectionHint}>Pick a system to see the integrations available for it.</p>
                </div>
                {endpoints.length > POPULAR_LIMIT ? (
                    <Link to={PATH.MARKETPLACE} className={Style.sectionLink}>
                        View all {endpoints.length} <i className="uil-angle-right" aria-hidden="true" />
                    </Link>
                ) : null}
            </div>
            {renderBody()}
        </section>
    )
}

export default PopularSystems
